export default [
  {
    path: '/masterdata/checkpoint',
    name: 'master-data-checkpoint',
    component: () => import('@/views/apps/master-data/location/location-list/location.vue'),
    meta: {
      pageTitle: 'Master Data - Checkpoint',
      breadcrumb: [
        {
          text: 'Master Data - Checkpoint',
          active: true,
        },
      ],
    },
  },
  {
    path: '/masterdata/checkpoint/create',
    name: 'master-data-checkpoint-create',
    component: () => import('@/views/apps/master-data/location/location-create/locationCreate.vue'),
  },
  {
    path: '/masterdata/checkpoint/edit/:id',
    name: 'master-data-checkpoint-edit',
    component: () => import('@/views/apps/master-data/location/location-edit/locationEdit.vue'),
  },
]
